import { Component, DestroyRef, inject, signal, WritableSignal } from '@angular/core';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { ContactPageHeaderComponent } from '@components/contact-page-header/contact-page-header.component';
import { LnLeftIconButtonComponent } from '@components/butons/ln-left-icon-button/ln-left-icon-button.component';
import { LnInstagramSvgIconComponent } from '@components/svg-icons/ln-instagram-svg-icon/ln-instagram-svg-icon.component';
import { LnWhatsappSvgIconComponent } from '@components/svg-icons/ln-whatsapp-svg-icon/ln-whatsapp-svg-icon.component';
import { MenuActions } from '../../shared/states/menu_actions';
import { environment } from '../../../environments/environment';
import { ContactPageFormOfContactComponent } from '@components/contact-page-form-of-contact/contact-page-form-of-contact.component';
import { UnsuccessfulOrderResponseCardComponent } from '@components/cards/unsuccessful-order-response-card/unsuccessful-order-response-card.component';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { timer } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DeviceScreenFamilyService } from '@core/services/device-screen-family/device-screen-family.service';
import { ScrollService } from '@core/services/scroll/scroll.service';
import { ClipBoardService } from '@core/services/clipBoard/clip-board.service';

@Component({
  selector: 'ln-contact',
  imports: [
    LnPagesArmorComponent,
    ContactPageHeaderComponent,
    LnLeftIconButtonComponent,
    LnInstagramSvgIconComponent,
    LnWhatsappSvgIconComponent,
    ContactPageFormOfContactComponent,
    UnsuccessfulOrderResponseCardComponent,
    TranslocoPipe,
    TranslocoDirective,
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css',
})
export class ContactComponent {
  menuAction = inject(MenuActions);
  private readonly INSTAGRAM_URL: string = environment.LN_INSTAGRAM_URL;
  private readonly WHATSAPP_URL: string = environment.LN_WHATSAPP_URL;
  protected showUnSuccessfulModal: WritableSignal<boolean> = signal(false);
  protected showUnSuccessfulOrderCardBottom: WritableSignal<boolean> = signal(true);
  private destroyRef = inject(DestroyRef);
  private deviceScreenFamily = inject(DeviceScreenFamilyService);
  protected currentScreenSize = this.deviceScreenFamily.currentDeviceScreenFamily;
  private scrollService = inject(ScrollService);
  private clipboard = inject(ClipBoardService);

  navigateToWhatsapp(message: string) {
    const encodedMessage = '?text=' + encodeURIComponent(message);
    this.menuAction.navigateToURL(this.WHATSAPP_URL + encodedMessage);
  }

  navigateToInstagram(message: string) {
    this.clipboard.copy(message)?.then(() => this.menuAction.navigateToURL(this.INSTAGRAM_URL));
  }

  protected presentUnSuccessfulModal() {
    this.showUnSuccessfulModal.set(true);
    this.showUnSuccessfulOrderCardBottom.set(true);
    if (this.currentScreenSize() === 'SM') {
      timer(1000)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.scrollToUnsuccessfulModal();
        });
    }
    this.closeUnSuccessfulModalAutomatically();
  }

  private scrollToUnsuccessfulModal() {
    this.scrollService.scrollToElementById('error-msg');
  }

  private closeUnSuccessfulModalAutomatically(): void {
    timer(5000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        if (this.showUnSuccessfulModal() || this.showUnSuccessfulOrderCardBottom()) {
          this.showUnSuccessfulModal.set(false);
          this.showUnSuccessfulOrderCardBottom.set(false);
        }
      });
  }
}
